// Mirrors the backend's admin permission-scope resolution. Runtime config may
// still use local-dev, but admin grants stay scoped to dev/uat/prod; local
// development therefore checks can_admin_envs.dev.
export function resolveCurrentEnv() {
  const mode = import.meta.env.MODE;
  if (mode === 'development' || mode === 'local-dev' || mode === 'local' || mode === 'localdev') {
    return 'dev';
  }
  if (mode === 'production') {
    return 'prod';
  }
  return mode;
}
